document.addEventListener('DOMContentLoaded', function() {
    window.expivi._events.onChange.subscribe(function(e) {
        if (e.name === "fully_loaded") { 
           expivi.setCameraTransform({
				position: {
					x: 3.1737532911804487,
					y: 2.5189928104891406,
					z: 2.900129478707215
					},
				quaternion: {
					w:0.9112824969602332,
					x:-0.2959819354528305,
					y:0.27228269487304146,
					z: 0.08843663659475746
					},
				scale: {
					x: -0.7151819793660638,
					y: 0.4599481146800299,
					z: 0.36799977796697697
				}
			})
        }
    });
});